import type { ContratCxpiDTO } from '@/features/api/extranet/dto/Demande/CXPI'
import type { ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import { CXPI_ACTIONS } from '@/features/interface/demande/cxpi/useDemandeCXPIActions'
import { useDemandeCXPIActions } from '@/features/interface/demande/cxpi/useDemandeCXPIActions.ts'
import type { SetupDemande } from '@/features/interface/demande/shared/components/DemandeContent/DemandeContent.types.ts'
import { type Component, provide } from 'vue'

import {
  CXPI_INTERRUPTIONS_ACTIONS,
  useInterruptionsActions,
} from '@/features/interface/demande/cxpi/steps/contrat/useInterruptionsActions.ts'
import {
  CXPI_MODULES_ACTIONS,
  useModuleActions,
} from '@/features/interface/demande/cxpi/steps/formation/useModuleActions.ts'
import {
  useReservationDemandeCXPIStore,
  useReservationDossierCXPIStore,
} from '@/features/interface/demande/cxpi/useCXPIStore.ts'
import DocumentsDossierStep from './steps/documents/DocumentsDossierStep.vue'
import SyntheseStep from './steps/synthese/SyntheseStep.vue'

type TabKey = 'Synthèse' | 'Documents'

const TABS_VUES: Record<TabKey, Component> = {
  Synthèse: SyntheseStep,
  Documents: DocumentsDossierStep,
} as const

const TABS_ERR_CONFIG: ErreurSummaryConfiguration<ContratCxpiDTO> = {
  Synthèse: {},
  Documents: {},
} as const

export const SetupDrfDossierCXPI: SetupDemande<'MODEL_CXPI', TabKey> = {
  useStore: useReservationDossierCXPIStore,
  injectActions: () => {
    const store = useReservationDemandeCXPIStore()
    const actions = useDemandeCXPIActions(store)
    provide(CXPI_ACTIONS, actions)
    return actions
  },
  tabFirst: 'Synthèse',
  tabsVue: TABS_VUES,
  tabsErrorConfig: () => TABS_ERR_CONFIG,
  onInititalize: () => {
    const store = useReservationDossierCXPIStore()
    provide(CXPI_MODULES_ACTIONS, useModuleActions(store))
    provide(CXPI_INTERRUPTIONS_ACTIONS, useInterruptionsActions(store))
  },
} as const
